function HandsIcon() {
  return (
    <svg
      width="323"
      height="323"
      viewBox="0 0 323 323"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M133.868 257.921C36.5749 237.031 -1.72775 105.992 74.8271 62.1119C152.178 17.7749 304.195 93.643 296.746 172.164C290.735 235.534 213.203 274.955 133.868 257.921Z"
        fill="#E6EFFF"
      />
      <path
        d="M307.45 109.223L208.779 38.3818C184.079 121.092 162.334 156.305 116.433 209.159L217.634 292.65C262.467 230.122 280.15 186.137 307.45 109.223Z"
        fill="#FFCC60"
      />
      <path d="M163.238 263.556L124.023 215.485L182.213 263.556H163.238Z" fill="#9DC3FF" />
      <path
        d="M179.768 212.326C182.677 212.326 186.219 212.849 189.045 212.093C192.26 211.233 195.411 209.767 198.65 209.067C202.463 208.244 209.425 206.409 211.815 210.208C215.172 215.545 207.449 219.458 203.147 220.613C199.877 221.491 195.239 223.332 191.809 222.358C191.181 222.18 191.826 221.303 192.09 221.125C192.959 220.538 194.046 220.706 195.042 220.706C196.724 220.706 197.728 221 198.931 222.196C199.927 223.186 200.008 224.764 200.008 226.06C200.008 228.887 201.282 230.5 204.038 231.413C207.068 232.417 210.141 232.437 213.291 232.437C215.325 232.437 216.261 235.099 216.43 236.86C216.624 238.88 215.947 241.298 216.547 243.238C217.281 245.608 220.753 245.479 222.779 245.845"
        stroke="#00307A"
        strokeWidth="3.79505"
        strokeLinecap="round"
      />
      <line
        x1="214.071"
        y1="258.82"
        x2="172.418"
        y2="224.108"
        stroke="#B75327"
        strokeWidth="5.06007"
        strokeLinecap="round"
      />
      <path
        d="M216.369 72.5381L260.644 105.429"
        stroke="#B75327"
        strokeWidth="5.06007"
        strokeLinecap="round"
      />
      <path
        d="M210.044 87.7183L278.355 137.054"
        stroke="#B75327"
        strokeWidth="5.06007"
        strokeLinecap="round"
      />
      <path
        d="M203.719 101.633L263.175 145.909"
        stroke="#B75327"
        strokeWidth="5.06007"
        strokeLinecap="round"
      />
      <path
        d="M197.394 116.813L264.44 167.414"
        stroke="#B75327"
        strokeWidth="5.06007"
        strokeLinecap="round"
      />
      <path
        d="M208.78 144.644L255.585 180.065"
        stroke="#B75327"
        strokeWidth="5.06007"
        strokeLinecap="round"
      />
      <path
        d="M154.383 192.715V185.125L175.888 187.655V196.51C175.888 196.51 173.358 202.835 164.503 201.57C158.241 200.675 154.383 192.715 154.383 192.715Z"
        fill="#974802"
      />
      <path
        d="M141.733 182.594L154.383 187.654C152.18 193.162 149.969 197.774 141.733 197.774C134.143 197.774 132.738 193.282 131.613 187.654L141.733 182.594Z"
        fill="#974802"
      />
      <path
        d="M111.373 161.089L177.154 187.655L182.214 156.029L161.973 130.729L121.493 119.344L111.373 126.934V161.089Z"
        fill="#974802"
      />
      <path
        d="M198.659 173.739C203.718 170.983 203.719 163.619 203.719 163.619L192.334 121.873C192.334 121.873 169.457 90.7991 159.443 87.7178C132.818 79.5253 115.168 90.2475 81.0122 100.368L121.493 130.728L156.913 134.523L167.033 163.619H174.623C174.623 163.619 190.102 178.398 198.659 173.739Z"
        fill="#B65F07"
      />
      <rect
        x="161.985"
        y="101.027"
        width="75.901"
        height="17.7102"
        transform="rotate(71.0035 161.985 101.027)"
        fill="#0452D0"
      />
      <rect
        x="163.633"
        y="105.812"
        width="12.6502"
        height="17.7102"
        transform="rotate(71.0035 163.633 105.812)"
        fill="#00307A"
      />
      <path
        d="M186.692 172.794L187.835 196.703C187.942 198.943 185.058 199.936 183.763 198.105L169.946 178.559L186.692 172.794Z"
        fill="#1E6DEB"
      />
      <path
        d="M136.253 32.2881C138.595 31.4818 141.147 32.7268 141.954 35.0689L164.564 100.747C165.37 103.089 164.125 105.641 161.783 106.448L148.734 110.94C146.392 111.746 143.84 110.501 143.034 108.159L120.423 42.4809C119.617 40.1388 120.862 37.5865 123.204 36.7802L136.253 32.2881Z"
        fill="#0452D0"
      />
      <path
        d="M136.253 32.2881C138.595 31.4818 141.147 32.7268 141.954 35.0689L144.611 42.7893L123.081 50.2013L120.423 42.4809C119.617 40.1388 120.862 37.5865 123.204 36.7802L136.253 32.2881Z"
        fill="#1E6DEB"
      />
      <path
        d="M140.573 38.8287L144.057 37.6294C147.57 36.4199 151.398 38.2875 152.608 41.8006L167.3 84.4792"
        stroke="#1E6DEB"
        strokeWidth="5.98008"
        strokeLinecap="round"
      />
      <path
        d="M163.552 97.8105L165.293 102.867C165.696 104.038 165.074 105.314 163.903 105.717L146.613 111.669C145.442 112.072 144.166 111.45 143.763 110.279L142.022 105.223L163.552 97.8105Z"
        fill="#1E6DEB"
      />
      <line
        x1="2.53003"
        y1="-2.53003"
        x2="7.5901"
        y2="-2.53003"
        transform="matrix(0.325511 0.945538 0.945538 -0.325511 143.709 32.3965)"
        stroke="#00307A"
        strokeWidth="5.06007"
        strokeLinecap="round"
      />
      <path
        d="M105.048 186.389C90.9982 183.416 75.9521 172.474 75.9521 172.474L78.4822 99.103L140.468 120.608L134.143 131.993L118.963 142.114C118.963 142.114 125.288 152.234 130.348 156.029C135.408 159.824 158.753 157.55 170.828 168.679C180.14 177.261 180.949 181.329 178.419 187.654C175.888 193.979 161.422 188.205 148.058 187.654C131.276 186.963 120.061 189.567 105.048 186.389Z"
        fill="#B65F07"
      />
      <path
        d="M77.0664 94.043H55.7122C52.9176 94.043 50.6521 96.3084 50.6521 99.103V175.004C50.6521 177.799 52.9176 180.064 55.7122 180.064H74.8341C77.5707 180.064 79.8115 177.888 79.8919 175.153L82.1243 99.2518C82.2082 96.4002 79.9193 94.043 77.0664 94.043Z"
        fill="white"
      />
      <path
        d="M54.4457 88.9834H26.1527C23.43 88.9834 21.1954 91.1378 21.096 93.8587L17.9524 179.88C17.8477 182.745 20.142 185.125 23.0091 185.125H54.4457C57.2403 185.125 59.5057 182.859 59.5057 180.065V94.0435C59.5057 91.2489 57.2403 88.9834 54.4457 88.9834Z"
        fill="#00307A"
      />
      <path
        d="M51.9163 152.234H81.0116L79.9113 176.442C79.8192 178.468 78.1491 180.064 76.1202 180.064H51.9163V152.234Z"
        fill="#9DC3FF"
      />
      <path
        d="M165.768 164.884C156.046 161.847 151.853 159.824 137.938 156.029C131.34 154.229 126.164 152.145 122.545 150.451C119.292 148.929 118.803 144.803 121.343 142.263L131.613 131.993L153.118 134.523"
        stroke="#522604"
        strokeWidth="5.06007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M153.118 188.919V193.98"
        stroke="#522604"
        strokeWidth="5.06007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0258 152.234H59.5063V181.329C59.5063 183.425 57.8072 185.124 55.7112 185.124H21.7046C19.5514 185.124 17.8296 183.335 17.9123 181.183L19.0258 152.234Z"
        fill="#001535"
      />
      <path
        d="M187.274 171.209L172.094 125.668"
        stroke="#522604"
        strokeWidth="5.06007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M137.939 154.763L136.674 144.643"
        stroke="#522604"
        strokeWidth="5.06007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M154.383 159.824L152.871 147.173"
        stroke="#522604"
        strokeWidth="5.06007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default HandsIcon;
